import DOMPurify from "dompurify"

export function sanitizeAmendsHtml(value) {
    return DOMPurify.sanitize(`${value ?? ""}`, {
        FORBID_TAGS: ["script", "iframe", "button", "form", "input"],
    })
}
